import React from "react";

import { Box, Loader } from "@braintrust/braintrust-ui-components";
import { Form } from "@js/forms/components/form";
import type { ReduxFormConfiguration } from "@js/forms/fields";
import { reduxForm } from "@js/forms/fields";
import type { OverwriteContentComponentProps } from "@js/layouts/app";
type FormLayoutWrapperProps<T> = OverwriteContentComponentProps & {
  formId: string;
  formProps: Partial<ReduxFormConfiguration<T>>;
  loading?: boolean;
  children: React.ReactNode;
  aboveContentFullWidthSocket?: React.ReactNode;
  enableReinitialize?: boolean;
};

export const FormLayoutWrapper = <T extends object>({
  alertsElement,
  contentBoxProps,
  headerBoxProps,
  formId,
  formProps,
  loading,
  children,
  aboveContentFullWidthSocket,
}: FormLayoutWrapperProps<T>) => {
  if (loading) {
    return (
      <Box sx={{ p: 8, position: "relative", height: "100%" }}>
        <Loader centered />
      </Box>
    );
  }

  return (
    <LayoutGenericForm form={formId} {...formProps}>
      <Box
        id="subheader-portal"
        sx={{
          position: "sticky",
          bgcolor: "var(--white)",
          top: headerBoxProps?.top,
          zIndex: headerBoxProps?.zIndex,
        }}
      />
      {alertsElement}
      {aboveContentFullWidthSocket}
      <Box
        className={contentBoxProps?.className}
        sx={{ overflow: contentBoxProps?.overflow }}
      >
        {children}
      </Box>
    </LayoutGenericForm>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LayoutGenericForm = reduxForm<any>()(({
  children,
  submitting,
  submit,
  error,
  form,
}) => {
  return (
    <Form
      id={form}
      name={form}
      error={error}
      onSubmit={submitting ? null : submit}
      preventSubmitOnEnter
    >
      {children}
    </Form>
  );
});
